import { Button, Stack, styled } from '@mui/material'
import { memo } from 'react'
import { Flex } from 'styles'
import ModalLink from 'components/ModalLink'
import { darkColor } from 'styles/constants/dark'
import { ReactComponent as IconWarning } from './warning.svg'
import { CancelAllType, useCancelAllStore } from './store'

const CancelWrap = styled(Stack)`
  align-items: center;
  padding: 24px;
`
const CancelMessage = styled('div')`
  font-size: 14px;
  line-height: 20px;
  padding: 32px 0;
  width: 100%;
  text-align: center;
`
const BtnWrap = styled(Flex)`
  width: 100%;
  gap: 14px;
`
const Btn = styled(Button)`
  flex: 1;
  justify-content: center;
  border-radius: 20px;
  height: 40px;
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  padding: 11px 12px;
  cursor: pointer;
  &.cancel {
    color: ${(props) => props.theme.color.text100};
    background: rgba(57, 65, 73, 1);
  }
  &.confirm {
    align-items: center;
    gap: 4px;
    border: 1px solid ${(props) => props.theme.color.primary30};
    background-color: ${(props) => props.theme.color.primary20};
    color: ${darkColor.text00};
  }
`

const typeText = {
  ALL: '',
  LIMIT: 'Limit ',
  STOP: 'Stop ',
}

export const CancelModal = memo<{
  visible: boolean
  message?: string
  onClose(): void
  onOk(type: CancelAllType): void
}>(({ visible, message, onClose, onOk }) => {
  const { type } = useCancelAllStore()

  return (
    <ModalLink
      width="360px"
      hideCloseBtn={true}
      isIn={visible}
      onClose={() => {
        onClose && onClose()
      }}
    >
      <CancelWrap>
        <IconWarning />
        <CancelMessage>
          {message ??
            `Are you sure you want to cancel all ${typeText[type]}orders?`}
        </CancelMessage>
        <BtnWrap>
          <Btn
            className="cancel"
            onClick={() => {
              onClose && onClose()
            }}
          >
            Cancel
          </Btn>
          <Btn
            className="confirm"
            onClick={() => {
              onOk && onOk(type)

              onClose && onClose()
            }}
          >
            Confirm
          </Btn>
        </BtnWrap>
      </CancelWrap>
    </ModalLink>
  )
})
